"use client";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { ChatContactListMessages } from "@/messages/chat/contact-list.messages";
import { ConversationView } from "@/types/conversation-filters.types";

type Props = {
  view: ConversationView;
  onViewChange: (view: ConversationView) => void;
  messages: ChatContactListMessages;
};

function ConversationTabs({ view, onViewChange, messages }: Props) {
  return (
    <Box>
      <ToggleButtonGroup
        value={view}
        exclusive
        fullWidth
        size="small"
        onChange={(_, newView: ConversationView | null) => {
          if (newView !== null) onViewChange(newView);
        }}
        sx={{
          gap: 1,
          "& .MuiToggleButtonGroup-grouped": {
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "0.75rem !important",
            textTransform: "none",
            fontSize: "0.8rem",
            fontWeight: 600,
            py: 0.9,
            gap: 0.75,
            color: "text.secondary",
            "&.Mui-selected": {
              borderColor: "primary.main",
              color: "primary.main",
              backgroundColor: "transparent",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "transparent",
            },
          },
        }}
      >
        <ToggleButton value={ConversationView.MY_CONVERSATIONS}>
          <PersonOutlineIcon sx={{ fontSize: "1.1rem" }} />
          {messages.myConversationsTab}
        </ToggleButton>
        <ToggleButton value={ConversationView.AI_AGENTS}>
          <SmartToyOutlinedIcon sx={{ fontSize: "1.1rem" }} />
          {messages.aiAgentsTab}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default ConversationTabs;
